import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../providers/AuthProvider";
import { paths } from "./paths";

function ProtectedRoute() {
  const { signed } = useAuth();
  const location = useLocation();

  // state.from é o que faz um deep link em /projects/12/inconsistencies
  // sobreviver a uma sessão expirada: o login devolve ao destino pretendido.
  return signed ? <Outlet /> : <Navigate to={paths.login} replace state={{ from: location }} />;
}

export default ProtectedRoute;
